declare global {
  interface Window {
    fbq: (
      command: 'track' | 'trackCustom' | 'init',
      eventName: string,
      params?: Record<string, unknown>,
      options?: { eventID: string }
    ) => void
  }
}

const isFbqAvailable = (): boolean => {
  return typeof window !== 'undefined' && typeof window.fbq === 'function'
}

/**
 * Fire a Meta Pixel event client-side with an event_id for deduplication.
 */
export function fbqTrack(
  eventName: string,
  params?: Record<string, unknown>,
  eventId?: string,
): void {
  if (!isFbqAvailable()) {
    if (process.env.NODE_ENV === 'development') {
      console.log('[Meta Pixel] Event:', eventName, params, 'eventId:', eventId)
    }

    return
  }

  if (eventId) {
    window.fbq('track', eventName, params || {}, { eventID: eventId })
  } else {
    window.fbq('track', eventName, params || {})
  }
}
